// pages/Dashboard.jsx
import React from 'react';
import StatsCards from '../components/Dashboard/StatsCards';
import RecentAlerts from '../components/Dashboard/RecentAlerts';
import LiveFleetOverview from '../components/Dashboard/LiveFleetOverview';

const Dashboard = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Overview</h1>
        <p className="text-gray-600">Fleet Admin Dashboard</p>
      </div>

      <StatsCards />
      <LiveFleetOverview /> {/* This will now show the OpenStreetMap */}
      <RecentAlerts />
    </div>
  );
};

export default Dashboard;